import React from 'react';
import { Background, StyledContainer } from './styled';

const Container = ({
  bg,
  children,
  className
}: {
  bg: string;
  children: React.ReactNode;
  className?: string;
}) => (
  <Background bg={bg}>
    <StyledContainer className={className}>{children}</StyledContainer>
  </Background>
);

export default Container;
